import React, {useEffect} from 'react';
import Sidebar from "./Sidebar";
import PDFViewer from "./PDFViewer";
import defaultTitleBackgroundImage from "../../assets/img/press-releases.jpg";

type ReportPageProps = {
    title: string;
    date: string;
    pdfSrc: string;
    onBack: () => void;
};

// @ts-ignore
const ReportPage: React.FC<ReportPageProps> = ({title, date, pdfSrc, onBack}) => {
    const backgroundImage = defaultTitleBackgroundImage;

    useEffect(() => {
        document.title = `${title} | LinkNYC`;
        return () => {
            document.title = "LinkNYC";
        };
    }, [title]);

    const section1Style = {
        backgroundImage: `url(${backgroundImage})`
    };

    const backToReportsButton = (
        <button onClick={onBack} className='back-to-reports-button'>
            ← Back to Reports
        </button>
    );

    return (
        <div className='top-div'>
            <section className='post-content-section-1' style={section1Style}>
                <div className='post-content-section-1-div'>
                    <h2>
                        <div></div>
                        {title}
                    </h2>
                </div>
            </section>
            <section className='post-content-section-2'>
                <Sidebar/>
                <div className='post-content' style={{width: '100%'}}>
                    {backToReportsButton}
                    <h3>
                        <div></div>
                    </h3>
                    <div className='post-content-date'>{date}</div>
                    <PDFViewer pdfSrc={pdfSrc}/>
                    <div style={{marginTop: '30px'}}>{backToReportsButton}</div>
                </div>
            </section>
        </div>
    );
};

export default ReportPage;
